const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M18.53 13.78a.75.75 0 1 0-1.06-1.06L12 18.19l-5.47-5.47a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0zm0-8a.75.75 0 0 0-1.06-1.06L12 10.19 6.53 4.72a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0z"/></svg>';
export {
  a as w
};
